import React from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { useIntl, Link } from "gatsby-plugin-intl";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";

const StyledWrapper = styled.div`
  display: ${(props) => (props.isShown ? "flex" : "none")};
  position: absolute;
  top: calc(100% + 0.4rem);
  right: ${(props) => (props.isLearnMore ? 0 : "-4rem")};
  width: 12rem;
  background-color: ${(props) => props.theme.color.darkGrey};
  flex-direction: column;
  align-items: flex-start;
  padding: 0.6rem 0.7rem;
  border-radius: 2px;
  z-index: 10;
`;

const StyledText = styled.div`
  color: ${(props) => props.theme.color.white};
  font-size: 0.7rem;
  line-height: 0.9rem;
`;

const StyledBadge = styled.div`
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  margin-bottom: 0.2rem;
  align-self: flex-end;
`;

const StyledCTA = styled.div`
  border: 1px solid ${(props) => props.theme.color.smoke};
  padding: 0.2rem 0.3rem;
  font-size: 0.7rem;
  margin-top: 0.4rem;
  border-radius: 2px;
  color: ${(props) => props.theme.color.smoke};
  align-self: flex-end;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const Badge = ({ img, ...props }) => {
  return <StyledBadge imgStyle={{ objectFit: "contain" }} fluid={img} />;
};

const ShippingTooltip = ({ isShown, isLearnMore }) => {
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    {
      sustainabilityIcon: file(
        relativePath: { eq: "Icon/sustainability.png" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 100, quality: 100, layout: CONSTRAINED)
        }
      }
    }
  `);
  return (
    <StyledWrapper isLearnMore={isLearnMore} isShown={isShown}>
      <StyledBadge>
        <StaticImage
          src="../../../images/Icon/sustainability.png"
          alt="sustainable"
        />
      </StyledBadge>
      <StyledText>
        {intl.formatMessage({
          id: `product.shippingTooltip.body`,
        })}
      </StyledText>
      {isLearnMore && (
        <StyledCTA
          onClick={() => {
            window.open("/king-children/sustainability", "_blank");
            return;
          }}
        >
          {intl.formatMessage({
            id: `product.shippingTooltip.cta`,
          })}
        </StyledCTA>
      )}
    </StyledWrapper>
  );
};

export default ShippingTooltip;
